import { render } from "./Home.vue?vue&type=template&id=23ee985c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=23ee985c&lang=css"

import exportComponent from "/Users/imacgregor/dev/habitstacker/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__